import axios from "axios";
import * as constants from "../constants";
import {navigate} from "gatsby";
import {ROOT_API_URL} from "../constants/http";

axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers.post['Content-Type'] = "application/json";

axios.interceptors.request.use(config => {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

// export const refreshToken = async () => {
//     try {
//         const url = constants.ROOT_API_URL + '/auth/refresh';
//         const refreshToken = localStorage.getItem('refreshToken');
//         if(refreshToken) {
//             const { data } = await axios.post(url, { refreshToken });
//             localStorage.setItem('accessToken', data.accessToken);
//             localStorage.setItem('refreshToken', data.refreshToken);
//         }
//     } catch (error) {
//         console.log(error.response.data)
//     }
// };

// const isTokenExpiringSoon = token => {
//     const { exp } = jwt_decode(token);
//     const now = Date.now() / 1000;
//     const diff = exp - now;
//     return diff <= 120;
// };

// const hasTokenBeenRefreshed = response => {
//     const { responseURL } = response.request;
//     return (
//         responseURL.endsWith('/api/auth/refresh')
//         || responseURL.endsWith('/api/auth/login')
//     )
// }

// // refresh tokens if exp date is close
// axios.interceptors.response.use(
//     (response) => {
//         if(hasTokenBeenRefreshed(response)) return response;

//         const token = localStorage.getItem('accessToken')
//         if(token && isTokenExpiringSoon(token)) {
//             refreshToken();
//         }

//         return response;
//     },
//     (error) => {
//         console.log(error)
//         console.log("Response error");
//         return Promise.reject(error);
//     }
// );

//constant variables
const ROOT_URL = process.env.GATSBY_API_URL + "/api";
export const WEB_URL = process.env.GATSBY_API_URL;

const postOptions = {
  headers: {
    "Content-Type": "application/json",
    // "Access-Control-Allow-Credentials": true,
  },
  // withCredentials: true
};

//other functions

export function createOrder() {
  const url = `${ROOT_URL}/order`;
  return generalCallPost(url, constants.CREATE_ORDER);
}

export function getOrder(code) {
  const url = `${ROOT_URL}/order/${code}`;
  return generalCallGet(url, constants.GET_ORDER);
}

export function verifySignatureFile(formData) {
  const url = `${ROOT_URL}/order/verify/signature`;
  return generalCallPostFile(url, constants.VERIFY_SIGNATURE_FILE, formData);
}

export function downloadPdf(order) {
  const url = `${WEB_URL}/order/${order}/download`;
  return url;
}

//main functions

export function generalCallPost(url, type, formData = null) {
  return dispatch => {
    return axios
      .post(url, JSON.stringify(formData), postOptions)
      .then(response => {
        dispatch(generalSuccess(response, type));
      })
      .catch(handleErrorResponse.bind(this, dispatch, type));
  };
}

export function generalCallGet(url, type) {
  return dispatch => {
    return axios
      .get(url, postOptions)
      .then(response => {
        dispatch(generalSuccess(response, type));
      })
      .catch(handleErrorResponse.bind(this, dispatch, type));
  };
}

function generalCallPostFile(url, type, formData) {
  return dispatch => {
    return axios
      .post(url, formData)
      .then(response => {
        dispatch(generalSuccess(response, type));
      })
      .catch(handleErrorResponse.bind(this, dispatch, type));
  };
}

//general functions
export function generalSuccess(response, type) {
  return {
    type: type,
    payload: response.data,
  };
}

export function networkProblem() {
  console.log("network problem");
}

export function generalError(error) {
  console.log("general error");
  return {
    type: constants.GENERAL_ERROR,
    payload: error,
  };
}

export function correctFormErrors(response, type) {
  return {
    type: type,
    payload: response.data,
  };
}

//helper functions
const handleErrorResponse = (dispatch, type, error) => {
  try {
    if (error.message === "Network Error" || error.response.status === 500) {
      dispatch(networkProblem());
    } else if (error.response.status >= 400 && error.response.status < 500) {
      dispatch(correctFormErrors(error.response, type));
    } else {
      dispatch(generalError(error.response));
    }
  } catch (e) {
    dispatch(generalError(error));
  }
};

const createAccessKey = key => ({
  type: constants.CREATE_ACCESS_KEY,
  payload: key,
});

export const generateKey = () => {
  return async dispatch => {
    try {
      const url = ROOT_API_URL + "/auth/keys";
      const { data } = await axios.post(url);
      dispatch(createAccessKey(data));
    } catch (err) {
      console.log(err.response);
    }
  };
};

export const deactivateKey = code => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/auth/keys/${code}/deactivate`;
      const { data } = await axios.post(url);
      dispatch({ type: constants.DEACTIVATE_ACCESS_KEY, payload: data });
    } catch (err) {
      console.log(err.response);
    }
  };
};

export const setOrderLoading = isLoading => ({
  type: constants.SET_ORDER_LOADING,
  payload: isLoading,
});

export const setOrder = order => ({
  type: constants.SET_ORDER,
  payload: order,
});

export const setBankAccountsOrder = order => ({
  type: constants.SET_BANK_ACCOUNTS_ORDER,
  payload: order,
});

export const fetchOrder = (code, lang = 'pl') => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/${code}/details`;
      const config = { headers: { "Accept-Language": lang } };
      const { data } = await axios.get(url, config);
      dispatch(setOrder(data));
    } catch (err) {
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
};

export const fetchBankAccountsOrder = (code, lang = 'pl') => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/bank-accounts/${code}`;
      const config = { headers: { "Accept-Language": lang } };
      const { data } = await axios.get(url, config);
      dispatch(setBankAccountsOrder(data.data));
    } catch (err) {
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
};

export const bankAccountsSetProvider = (code, requestBody, lang = 'pl') => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/bank-accounts/${code}/verification-provider`;
      const config = { headers: { "Accept-Language": lang } };
      const { data } = await axios.put(url, requestBody,  config);
      dispatch(setBankAccountsOrder(data.data));
    } catch (err) {
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
}

export const getAutobillsOrder = code => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/${code}/details`;
      const config = { headers: { "Accept-Language": "pl" } };
      const { data } = await axios.get(url, config);
      dispatch({
        type: constants.SET_AUTOBILLS_ORDER,
        payload: data,
      });
    } catch (err) {
      const { error } = err?.response?.data;
      if (error) {
        dispatch({
          type: constants.SET_AUTOBILLS_ORDER,
          payload: { error },
        });
      }
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
};

export const resetOrder = (code, lang) => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/${code}`;
      const config = { headers: { "Accept-Language": lang } };
      const { data } = await axios.put(url, config);
      dispatch(setOrder(data));
    } catch (err) {
      console.log(err);
    }
  };
};

export const createChildrenOrder = (code, params) => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/${code}/orders`;
      const config = { headers: { "Accept-Language": "pl" } };
      const { data } = await axios.post(url, params, config);
      dispatch(setOrder(data));
    } catch (err) {
      const { error } = err?.response?.data;
      if (error) {
        dispatch(setOrder({ error }));
      }
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
};

export const deleteChildrenOrder = code => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/${code}`;
      const config = { headers: { "Accept-Language": "pl" } };
      const { data } = await axios.delete(url, config);
      dispatch(setOrder(data));
    } catch (err) {
      const { error } = err?.response?.data;
      if (error) {
        dispatch(setOrder({ error }));
      }
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
};

export const completeOrder = code => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/orders/${code}/complete`;
      const config = { headers: { "Accept-Language": "pl" } };
      const { data } = await axios.post(url, config);
      dispatch(setOrder(data));
    } catch (err) {
      const { error } = err?.response?.data;
      if (error) {
        dispatch(setOrder({ error }));
      }
      if (err.response && err.response.status === 404) {
        navigate("/404");
      }
    }
  };
};

export const getAccessKeys = () => {
  return async dispatch => {
    try {
      const url = `${ROOT_API_URL}/auth/keys`;
      const { data } = await axios.get(url);
      dispatch({ type: constants.GET_ACCESS_KEYS, payload: data });
    } catch (err) {
      console.log(err);
    }
  };
};
